export default "__VITE_ASSET__lw$5Oxj0__"